import React from 'react';
import { Link } from 'react-router-dom';
import { images } from '../../assets/image';

export default function Forgot() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 font-sans p-4">
            <div className="w-full max-w-md bg-white p-8 sm:p-10 rounded-2xl shadow-sm border border-gray-100">
                <div className="text-center mb-8">
                    <span className="text-[30px] font-black tracking-tighter text-[#111827]">School-<span className='text-blue-500'>OS</span></span>
                    <h1 className="text-2xl font-bold text-gray-900 mb-2">Reset password</h1>
                    <p className="text-sm text-gray-500">Enter your mobile number to receive a recovery link</p>
                </div>

                <form className="flex flex-col gap-5 text-left" onSubmit={(e) => e.preventDefault()}>
                    <div className="flex flex-col gap-1.5">
                        <label className="text-sm font-medium text-gray-700">Email</label>
                        <input
                            type="email"
                            className="w-full h-11 px-4 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent transition-all placeholder-gray-400"
                            placeholder="e.g. jhondoe@gmail.com"
                        />
                    </div>

                    <button type="submit" className="mt-2 w-full h-11 bg-blue-500 hover:bg-blue-600 active:scale-[0.98] text-white rounded-lg text-sm font-semibold transition-all shadow-md shadow-gray-200">
                        Send Recovery Link
                    </button>
                </form>

                <div className="mt-8 pt-6 border-t border-gray-100 text-center">
                    <Link to="/login" className="text-sm font-semibold text-gray-900 hover:underline">
                        Back to log in
                    </Link>
                </div>
            </div>
        </div>
    );
}